import React from 'react';
import { Button, Upload, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { localFilesSelector } from '../../store/selectors';
import { setLocalFiles } from '../../store/actions';

const Btn = (props) => <Button {...props} />;

const UploadLocalFiles = ({ disabled, btnClassName }) => {
  const dispatch = useDispatch();
  const localFiles = useSelector(localFilesSelector);

  const handleBeforeUpload = (_file, fileList) => {
    dispatch(setLocalFiles(fileList));
    return false;
  };

  return (
    <Upload
      name="file"
      fileList={localFiles}
      multiple={true}
      beforeUpload={handleBeforeUpload}
      showUploadList={false}
    >
      <Tooltip title="Прикрепить файлы">
        <Btn icon="paper-clip" disabled={disabled} className={btnClassName} />
      </Tooltip>
    </Upload>
  );
};

export default UploadLocalFiles;
